/**
 * Represents the restriction options for a [[Discount]].
 */
export var DiscountRestriction;
(function (DiscountRestriction) {
    /**
     * Redemption of a [[MemberReward]] with one of the specified [[Discount.rewardIds]] is required.
     */
    DiscountRestriction["MemberReward"] = "MemberReward";
    /**
     * Redemption of an [[OrderVoucher]] with one of the specified [[Discount.voucherTypeCodes]] is required.
     */
    DiscountRestriction["Voucher"] = "Voucher";
    /**
     * Access to the discount is subject to [[DiscountAvailability]].
     *
     * @remarks
     * The [[DiscountAvailability.IsAvailable]] must equal `true` to use the discount.
     * Only applicable to item discounts as ticket discounts are automatically filtered for the relevant showtime.
     * Will only be returned if discount availability restrictions are enabled.
     */
    DiscountRestriction["Availability"] = "Availability";
})(DiscountRestriction || (DiscountRestriction = {}));
//# sourceMappingURL=discount-restriction.js.map